import Film from 'src/components/Film';

function MoviePage() {
    return (
        <>
            <Film mediaType="movie" />
        </>
    );
}

export default MoviePage;
